module.exports = __webpack_public_path__ + "static/media/seeder-leatherworking-tool.063da0ef.webp";